import { render, staticRenderFns } from "./registrationFor1.vue?vue&type=template&id=860cb4e6&scoped=true"
import script from "./registrationFor1.vue?vue&type=script&lang=js"
export * from "./registrationFor1.vue?vue&type=script&lang=js"
import style0 from "./registrationFor1.vue?vue&type=style&index=0&id=860cb4e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860cb4e6",
  null
  
)

export default component.exports